/* wicanders-samples.js - DRAFT 2026-10-07, unpublished theme only.
 *
 * ONE cart. Shopify's own. All four collections write into the same
 * /cart.js, because all 25 Wicanders samples are variants of a single
 * product, so "GO +2, ESSENCE +3, INSPIRE +1" is six lines of one cart with
 * no merging logic required and nothing to go out of sync.
 *
 * What this file deliberately does NOT do:
 *   - It does not keep its own copy of the cart. Every number on screen is
 *     repainted from a /cart.js response. localStorage holds questionnaire
 *     text only, and the server's cart attributes outrank it.
 *   - It does not gate checkout. The live page has no validation of any kind
 *     on these questions, so there is none to preserve, and a browser-side
 *     gate would not be enforcement anyway - it would only be a speed bump a
 *     shopper can step around with devtools or a direct /cart/add.js POST.
 *     The questions are presented as optional, exactly as they are today.
 *   - It does not remove cart lines by index. It changes them by LINE KEY,
 *     scoped to this product id, so a shopper who already has a real Eco
 *     product in the cart cannot have it silently deleted by a sample edit.
 *     (The live block removes by `line: index + 1`, which can.)
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-wic-samples]');
  if (!root) return;

  var PRODUCT_ID = String(root.getAttribute('data-product-id') || '');
  var CURRENCY = root.getAttribute('data-currency') || 'USD';
  var MAX_PER = parseInt(root.getAttribute('data-max-per-sample') || '0', 10) || 0;

  var LS_KEY = 'wicanders-sample-questions';
  var NOTE_OPEN = '[WICANDERS PROJECT INFO]';
  var NOTE_CLOSE = '[/WICANDERS PROJECT INFO]';
  var ATTR_PREFIX = 'Wicanders project - question ';

  /* ------------------------------------------------------------- elements */
  var tablist = root.querySelector('[data-wic-tablist]');
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-wic-tab]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-wic-panel]'));
  var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-wic-tile]'));
  var fields = Array.prototype.slice.call(root.querySelectorAll('[data-wic-field]'));
  var statuses = Array.prototype.slice.call(root.querySelectorAll('[data-wic-status]'));
  var openCartBtns = Array.prototype.slice.call(root.querySelectorAll('[data-wic-open-cart]'));
  var openCartNs = Array.prototype.slice.call(root.querySelectorAll('[data-wic-open-cart-n]'));

  var dlg = root.querySelector('[data-wic-dialog]');
  var dImg = root.querySelector('[data-wic-dlg-img]');
  var dChip = root.querySelector('[data-wic-dlg-chip]');
  var dTitle = root.querySelector('[data-wic-dlg-title]');
  var dPrice = root.querySelector('[data-wic-dlg-price]');
  var dFull = root.querySelector('[data-wic-dlg-full]');
  var dSku = root.querySelector('[data-wic-dlg-sku]');
  var dAvail = root.querySelector('[data-wic-dlg-avail]');
  var dQty = root.querySelector('[data-wic-dlg-qty]');
  var dMinus = root.querySelector('[data-wic-dlg-minus]');
  var dPlus = root.querySelector('[data-wic-dlg-plus]');
  var dAdd = root.querySelector('[data-wic-dlg-add]');
  var dMsg = root.querySelector('[data-wic-dlg-msg]');
  var dBack = root.querySelector('[data-wic-dlg-back]');

  var trayCount = root.querySelector('[data-wic-count]');
  var trayEmpty = root.querySelector('[data-wic-empty]');
  var trayItems = root.querySelector('[data-wic-items]');
  var traySub = root.querySelector('[data-wic-subtotal]');
  var trayOther = root.querySelector('[data-wic-other]');

  var bar = root.querySelector('[data-wic-bar]');
  var barCount = root.querySelector('[data-wic-bar-count]');
  var barStatus = root.querySelector('[data-wic-bar-status]');
  var live = root.querySelector('[data-wic-live]');
  var saved = root.querySelector('[data-wic-saved]');

  var tileByVariant = {};
  tiles.forEach(function (t) { tileByVariant[t.getAttribute('data-variant')] = t; });

  var current = null;   // the tile whose sample the dialog is showing
  var cart = null;      // last /cart.js response

  /* --------------------------------------------------------------- helpers */
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function say(msg) { if (live) live.textContent = msg; }

  function note(msg, kind) {
    if (!dMsg) return;
    dMsg.textContent = msg || '';
    if (kind) dMsg.setAttribute('data-kind', kind);
    else dMsg.removeAttribute('data-kind');
  }

  /* Serialise every cart write. Two taps in flight at once against
     /cart/change.js is how line keys go stale and quantities jump. */
  var chain = Promise.resolve();
  function queue(fn) {
    chain = chain.then(fn, fn);
    return chain;
  }

  var inflight = {};
  function once(key, fn) {
    if (inflight[key]) return inflight[key];
    inflight[key] = queue(fn)['catch'](function (e) { throw e; });
    var clear = function () { delete inflight[key]; };
    inflight[key].then(clear, clear);
    return inflight[key];
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error((j && (j.description || j.message)) || ('HTTP ' + r.status));
        return j;
      });
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  /* Our lines vs everything else. Nothing outside wicLines() is ever written. */
  function wicLines() {
    if (!cart || !cart.items) return [];
    return cart.items.filter(function (i) { return String(i.product_id) === PRODUCT_ID; });
  }
  function otherLines() {
    if (!cart || !cart.items) return [];
    return cart.items.filter(function (i) { return String(i.product_id) !== PRODUCT_ID; });
  }
  function qtyOf(variantId) {
    var n = 0;
    wicLines().forEach(function (i) { if (String(i.variant_id) === String(variantId)) n += i.quantity; });
    return n;
  }
  function collOf(variantId) {
    var t = tileByVariant[String(variantId)];
    return t ? (t.getAttribute('data-coll') || '') : '';
  }
  function shortOf(variantId) {
    var t = tileByVariant[String(variantId)];
    return t ? (t.getAttribute('data-short') || '') : '';
  }

  /* --------------------------------------------------- questionnaire state */
  function readFields() {
    var out = [];
    fields.forEach(function (f) {
      var ta = f.querySelector('textarea');
      out.push({
        n: f.getAttribute('data-n'),
        attr: f.getAttribute('data-attr'),
        label: f.getAttribute('data-label') || '',
        value: ta ? ta.value.trim() : ''
      });
    });
    return out;
  }

  function answeredCount() {
    return readFields().filter(function (f) { return f.value; }).length;
  }

  function saveLocal() {
    try {
      var o = {};
      readFields().forEach(function (f) { o[f.n] = f.value; });
      localStorage.setItem(LS_KEY, JSON.stringify(o));
    } catch (e) { /* private mode: the cart still carries the answers */ }
  }

  function loadLocal() {
    try {
      var o = JSON.parse(localStorage.getItem(LS_KEY) || '{}');
      fields.forEach(function (f) {
        var ta = f.querySelector('textarea');
        var v = o[f.getAttribute('data-n')];
        if (ta && !ta.value && v) ta.value = v;
      });
    } catch (e) { /* ignore */ }
  }

  /* The Q/A block is written in the SAME shape the live page writes today -
     "Q1: <label>", "A1: <answer>", a 28-dash rule, numbering only the
     questions that were actually answered - so anything downstream that
     already parses these order notes keeps working unchanged. The difference
     is that it is fenced, so a note the shopper typed themselves at /cart
     survives instead of being overwritten. */
  function buildNote(existing) {
    var body = '';
    var n = 1;
    readFields().forEach(function (f) {
      if (!f.value) return;
      body += 'Q' + n + ': ' + f.label + '\n';
      body += 'A' + n + ': ' + f.value + '\n';
      body += '----------------------------\n';
      n++;
    });
    var block = body ? (NOTE_OPEN + '\n' + body.replace(/\n+$/, '') + '\n' + NOTE_CLOSE) : '';

    var rest = String(existing || '');
    var o = rest.indexOf(NOTE_OPEN);
    var c = rest.indexOf(NOTE_CLOSE);
    if (o !== -1 && c !== -1 && c > o) {
      rest = (rest.slice(0, o) + rest.slice(c + NOTE_CLOSE.length));
    }
    rest = rest.replace(/\n{3,}/g, '\n\n').trim();

    if (!block) return rest;
    return rest ? (block + '\n\n' + rest) : block;
  }

  /* Attributes carry the SAME answers as named key/value pairs. This is
     additive - it does not replace or reshape the note - and it means the
     responses themselves are on the order, not a bare "complete" flag. */
  function buildAttributes() {
    var attrs = {};
    readFields().forEach(function (f) {
      attrs[ATTR_PREFIX + f.n] = f.value || '';
    });
    attrs['Wicanders project - questions answered'] = String(answeredCount()) + ' of ' + String(fields.length);
    return attrs;
  }

  /* ------------------- project info belongs to the SAMPLES -------------------
     The cart may carry the Wicanders answers only while a Wicanders sample line
     is actually in it. Without that condition the answers were written on the
     first change/blur even with an empty cart, and were left behind when the
     last sample was removed - so a shopper who answered the questions and then
     bought something unrelated carried a [WICANDERS PROJECT INFO] note and the
     "Wicanders project - question N" attributes onto that order.

     Two halves, and both are needed:
       - nothing is WRITTEN while no sample line exists, and
       - anything already written is CLEARED as soon as the last sample goes,
     because the guard alone would leave an existing note sitting in the cart.
     The textareas keep their own localStorage mirror either way, so nothing a
     shopper typed is lost - it simply does not reach the order until there is
     an order for it to describe.

     Same fix, same shape, as the Forbo package (forbo-wic-core.js). */
  function wicAttrKeys() {
    var keys = readFields().map(function (f) { return ATTR_PREFIX + f.n; });
    keys.push('Wicanders project - questions answered');
    return keys;
  }
  function blankAttributes() {
    var attrs = {};
    wicAttrKeys().forEach(function (k) { if (k) attrs[k] = ''; });
    return attrs;
  }
  /* buildNote() splices our fenced block OUT of an existing note before
     re-adding it; this is that splice on its own, for the clearing path. */
  function stripBlock(existing) {
    var rest = String(existing || '');
    var o = rest.indexOf(NOTE_OPEN);
    var c = rest.indexOf(NOTE_CLOSE);
    if (o !== -1 && c !== -1 && c > o) {
      rest = (rest.slice(0, o) + rest.slice(c + NOTE_CLOSE.length));
    }
    return rest.replace(/\n{3,}/g, '\n\n').trim();
  }
  /* Is there Wicanders data in the cart right now that no sample justifies? */
  function staleInCart() {
    if (!cart) return false;
    if (String(cart.note || '').indexOf(NOTE_OPEN) !== -1) return true;
    var a = cart.attributes || {};
    return wicAttrKeys().some(function (k) { return k && a[k]; });
  }
  /* Unqueued: every caller below is already inside the serialised chain. */
  function reapCore() {
    if (wicLines().length) return Promise.resolve(cart);
    if (!staleInCart()) return Promise.resolve(cart);
    return post('/cart/update.js', {
      attributes: blankAttributes(),
      note: stripBlock(cart && cart.note)
    }).then(function (c) {
      cart = c;
      paintStatus();
      paint();
      return c;
    });
  }
  function reapProjectInfo() { return queue(reapCore); }

  function pushQuestionnaire() {
    saveLocal();
    return queue(function () {
      return getCart().then(function (c) {
        cart = c;
        /* No Wicanders sample in the cart: write nothing, and clear anything
           stale, so the answers never ride along on an unrelated order. */
        if (!wicLines().length) {
          return reapCore().then(function () {
            if (saved) saved.textContent = '';
          });
        }
        return post('/cart/update.js', {
          note: buildNote(c && c.note),
          attributes: buildAttributes()
        }).then(function (c2) {
          cart = c2;
          paint();
          if (saved) {
            saved.textContent = answeredCount()
              ? 'Saved to your order.'
              : '';
          }
        });
      })['catch'](function () {
        if (saved) saved.textContent = 'Could not save just now - your answers are still in this browser.';
      });
    });
  }

  function hydrateFromCart() {
    loadLocal();
    if (cart && cart.attributes) {
      var any = false;
      fields.forEach(function (f) {
        var ta = f.querySelector('textarea');
        var v = cart.attributes[ATTR_PREFIX + f.getAttribute('data-n')];
        if (ta && v) { ta.value = v; any = true; }   // server wins over localStorage
      });
      if (any) saveLocal();
    }
    /* The samples can also be removed from the theme's own cart drawer, where
       this script is not running. Catch that on the next visit to this page:
       no sample line, but project info in the cart -> clear it. */
    reapProjectInfo();
  }

  /* ------------------------------------------------------------ cart writes */
  function addSample(variantId, qty) {
    return once('add:' + variantId, function () {
      return post('/cart/add.js', {
        items: [{
          id: Number(variantId),
          quantity: qty,
          properties: { '_wicanders_sample': '1' }
        }]
      }).then(function (added) {
        // Keep the questionnaire on the cart after every add, the way the
        // live block does, so a late answer still reaches the order. The NOTE
        // goes on here as well: until this moment there was no sample line, so
        // the guard in pushQuestionnaire refused to write, and answers typed
        // before the first sample would otherwise never reach the order.
        // /cart/add.js does not touch the note, so `added.note` is the current
        // one to splice.
        return post('/cart/update.js', {
          attributes: buildAttributes(),
          note: buildNote(added && added.note)
        });
      }).then(function () {
        return getCart();
      }).then(function (c) { cart = c; paint(); syncThemeBadges(); });
    });
  }

  /* Change by LINE KEY, never by index. */
  function setLine(key, qty) {
    return once('line:' + key, function () {
      return post('/cart/change.js', { id: key, quantity: qty })
        .then(function (c) { cart = c; return reapCore(); })
        .then(function () { paint(); syncThemeBadges(); });
    });
  }

  /* The theme's own header badges read the cart on page load. After an AJAX
     write they are stale, so repaint the ones this theme uses. */
  function syncThemeBadges() {
    if (!cart) return;
    ['#fcCount', '.float_count', '.cart-count', '[data-cart-count]'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('[data-wic-samples]')) return;
        el.textContent = String(cart.item_count);
      });
    });
    document.querySelectorAll('#fcTotal').forEach(function (el) {
      el.textContent = money(cart.total_price);
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    if (window.theme && window.theme.cart && typeof window.theme.cart.updateCart === 'function') {
      try { window.theme.cart.updateCart(); } catch (e) { /* theme's own problem */ }
    }
  }

  /* ----------------------------------------------------------------- paint */
  function paint() {
    var lines = wicLines();
    var count = 0, subtotal = 0;
    lines.forEach(function (i) { count += i.quantity; subtotal += i.final_line_price; });

    // tile badges
    tiles.forEach(function (t) {
      var badge = t.querySelector('[data-wic-tile-count]');
      if (!badge) return;
      var n = qtyOf(t.getAttribute('data-variant'));
      if (n > 0) { badge.textContent = String(n); badge.hidden = false; }
      else { badge.textContent = ''; badge.hidden = true; }
    });

    // Tab counts stay as catalogue counts. The review button carries the cart
    // count, and only the in-page one hides when the cart is empty - the
    // mobile bar button stays reachable so the tray is always one tap away.
    openCartNs.forEach(function (el) { el.textContent = String(count); });
    openCartBtns.forEach(function (b) {
      if (b.closest('.wic-samples__review')) b.hidden = count === 0;
    });

    // tray
    if (trayCount) {
      trayCount.textContent = count === 0
        ? 'No samples selected yet'
        : (count + (count === 1 ? ' sample' : ' samples') +
           ' across ' + distinctCollections(lines));
    }
    if (trayEmpty) trayEmpty.hidden = count > 0;
    if (traySub) traySub.textContent = money(subtotal);

    if (trayItems) {
      trayItems.innerHTML = '';
      lines.forEach(function (i) { trayItems.appendChild(itemRow(i)); });
    }

    // Unrelated products are reported, never touched.
    if (trayOther) {
      var others = otherLines();
      if (others.length) {
        var n = others.reduce(function (a, i) { return a + i.quantity; }, 0);
        trayOther.textContent = 'Your cart also holds ' + n + ' other item' + (n === 1 ? '' : 's') +
          ' that are not samples. They stay exactly as they are.';
        trayOther.hidden = false;
      } else {
        trayOther.hidden = true;
        trayOther.textContent = '';
      }
    }

    // mobile bar
    if (bar) {
      // No samples yet means no cart to review, so the sticky bar stays out of
      // the way rather than docking an empty bar over the grid on a phone.
      bar.hidden = count === 0;
      if (barCount) {
        barCount.textContent = count === 0 ? 'No samples yet'
          : (count + (count === 1 ? ' sample' : ' samples') + ' - ' + money(subtotal));
      }
    }

    paintStatus();
    if (current) paintDialogFor(current, true);
  }

  function distinctCollections(lines) {
    var seen = {};
    lines.forEach(function (i) {
      var c = collOf(i.variant_id);
      if (c) seen[c] = true;
    });
    var keys = Object.keys(seen);
    return keys.length + (keys.length === 1 ? ' collection' : ' collections');
  }

  function paintStatus() {
    var n = answeredCount();
    var total = fields.length;
    statuses.forEach(function (el) {
      el.textContent = n === 0
        ? 'Not answered yet (optional)'
        : (n + ' of ' + total + ' answered');
      el.className = 'wic-status ' + (n > 0 ? 'wic-status--done' : 'wic-status--todo');
    });
    if (barStatus) {
      barStatus.textContent = n === 0 ? 'Project info optional' : (n + ' of ' + total + ' questions answered');
      barStatus.setAttribute('data-ok', n > 0 ? '1' : '0');
    }
  }

  function itemRow(line) {
    var li = document.createElement('li');
    var vid = String(line.variant_id);
    var coll = collOf(vid);
    var short = shortOf(vid) || line.variant_title || line.product_title;

    var wrap = document.createElement('div');
    wrap.className = 'wic-item';

    var img = document.createElement('img');
    img.className = 'wic-item__thumb';
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    if (line.image) img.src = line.image.replace(/(\.[a-z]+)(\?|$)/i, '_112x84_crop_center$1$2');
    wrap.appendChild(img);

    var main = document.createElement('div');
    main.className = 'wic-item__main';

    var top = document.createElement('div');
    top.className = 'wic-item__top';
    if (coll) {
      var chip = document.createElement('span');
      chip.className = 'wic-chip wic-item__chip';
      chip.setAttribute('data-key', coll);
      chip.textContent = coll;
      top.appendChild(chip);
    }
    var nm = document.createElement('span');
    nm.className = 'wic-item__name';
    nm.textContent = short;
    top.appendChild(nm);
    main.appendChild(top);

    if (line.sku) {
      var sk = document.createElement('span');
      sk.className = 'wic-item__sku';
      sk.textContent = line.sku;
      main.appendChild(sk);
    }

    var row = document.createElement('div');
    row.className = 'wic-item__row';

    var qbox = document.createElement('div');
    qbox.className = 'wic-item__qty';
    var minus = document.createElement('button');
    minus.type = 'button';
    minus.textContent = '−';
    minus.setAttribute('aria-label', 'Decrease quantity of ' + short);
    var num = document.createElement('span');
    num.textContent = String(line.quantity);
    var plus = document.createElement('button');
    plus.type = 'button';
    plus.textContent = '+';
    plus.setAttribute('aria-label', 'Increase quantity of ' + short);
    minus.addEventListener('click', function () {
      setLine(line.key, Math.max(0, line.quantity - 1));
      say(short + (line.quantity - 1 <= 0 ? ' removed.' : ' quantity ' + (line.quantity - 1) + '.'));
    });
    plus.addEventListener('click', function () {
      if (MAX_PER && line.quantity >= MAX_PER) { say('Maximum of ' + MAX_PER + ' per sample.'); return; }
      setLine(line.key, line.quantity + 1);
      say(short + ' quantity ' + (line.quantity + 1) + '.');
    });
    qbox.appendChild(minus); qbox.appendChild(num); qbox.appendChild(plus);
    row.appendChild(qbox);

    var pr = document.createElement('span');
    pr.className = 'wic-item__price';
    pr.textContent = line.final_line_price === 0 ? 'Free' : money(line.final_line_price);
    row.appendChild(pr);

    var rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'wic-item__rm';
    rm.textContent = 'Remove';
    rm.setAttribute('aria-label', 'Remove ' + short);
    rm.addEventListener('click', function () {
      setLine(line.key, 0);
      say(short + ' removed.');
    });
    row.appendChild(rm);

    main.appendChild(row);
    wrap.appendChild(main);
    li.appendChild(wrap);
    return li;
  }

  /* ---------------------------------------------------------------- dialog */
  function paintDialogFor(tile, quiet) {
    var vid = tile.getAttribute('data-variant');
    var avail = tile.getAttribute('data-available') === '1';
    var inCart = qtyOf(vid);

    if (dChip) {
      var c = tile.getAttribute('data-coll') || '';
      dChip.textContent = c;
      dChip.setAttribute('data-key', c);
      dChip.hidden = !c;
    }
    if (dTitle) dTitle.textContent = tile.getAttribute('data-short') || '';
    if (dPrice) dPrice.textContent = tile.getAttribute('data-price-formatted') || '';
    if (dFull) dFull.textContent = tile.getAttribute('data-fullname') || '';
    if (dSku) dSku.textContent = tile.getAttribute('data-sku') || '';

    if (dImg) {
      var src = tile.getAttribute('data-image-large');
      if (src && dImg.getAttribute('src') !== src) {
        dImg.setAttribute('src', src);
        var w = tile.getAttribute('data-image-w');
        var h = tile.getAttribute('data-image-h');
        if (w) dImg.setAttribute('width', w);
        if (h) dImg.setAttribute('height', h);
      }
      dImg.alt = tile.getAttribute('data-image-alt') || tile.getAttribute('data-fullname') || '';
    }

    if (dAvail) {
      var txt = avail ? 'Available to order' : 'Currently unavailable';
      if (avail && inCart) txt += ' · ' + inCart + ' in your cart';
      else if (!avail && inCart) txt += ' · ' + inCart + ' already in your cart';
      dAvail.textContent = txt;
      dAvail.setAttribute('data-ok', avail ? '1' : '0');
    }

    if (dAdd) {
      dAdd.disabled = !avail;
      dAdd.textContent = inCart ? 'Add another to sample cart' : 'Add to sample cart';
    }
    if (dBack) dBack.hidden = inCart === 0;
    if (!quiet) {
      if (dQty) dQty.value = '1';
      note('');
    }
  }

  function openFor(tile) {
    current = tile;
    dlg.removeAttribute('data-cartonly');
    paintDialogFor(tile, false);
    if (!dlg.open) dlg.showModal();
    if (dQty) try { dQty.focus(); } catch (e) { /* ignore */ }
  }

  function openCartOnly() {
    current = null;
    dlg.setAttribute('data-cartonly', '1');
    if (!dlg.open) dlg.showModal();
    var first = root.querySelector('[data-wic-items] button');
    if (first) try { first.focus(); } catch (e) { /* ignore */ }
  }

  function clampQty() {
    var n = parseInt((dQty && dQty.value) || '1', 10);
    if (!isFinite(n) || n < 1) n = 1;
    if (MAX_PER && n > MAX_PER) n = MAX_PER;
    if (dQty) dQty.value = String(n);
    return n;
  }

  /* ------------------------------------------------------------------ tabs */
  function selectTab(key, focus) {
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-wic-tab') === key;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
      if (on && focus) t.focus();
    });
    panels.forEach(function (p) {
      p.hidden = p.getAttribute('data-wic-panel') !== key;
    });
    // Nothing reloads and nothing is re-fetched: the cart lives in Shopify,
    // not in the panel, so every selection made in another tab is still there.
    lazyScan();
    say(key + ' collection shown. Your selected samples are unchanged.');
  }

  tabs.forEach(function (t) {
    t.addEventListener('click', function () { selectTab(t.getAttribute('data-wic-tab'), false); });
  });

  if (tablist) {
    tablist.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement);
      if (i === -1) return;
      var j = -1;
      if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = tabs.length - 1;
      if (j === -1) return;
      e.preventDefault();
      selectTab(tabs[j].getAttribute('data-wic-tab'), true);
    });
  }

  // Clicking a row of the comparison table jumps to that collection.
  root.querySelectorAll('[data-wic-compare-row] .wic-chip').forEach(function (chip) {
    var key = chip.getAttribute('data-key');
    if (!key) return;
    var tab = tabs.filter(function (t) { return t.getAttribute('data-wic-tab') === key; })[0];
    if (!tab) return;
    chip.setAttribute('role', 'button');
    chip.setAttribute('tabindex', '0');
    chip.style.cursor = 'pointer';
    chip.title = 'Show the ' + key + ' samples';
    var go = function (e) {
      e.preventDefault();
      selectTab(key, false);
      var h = root.querySelector('#wic-samples-grid');
      if (h) h.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    chip.addEventListener('click', go);
    chip.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') go(e);
    });
  });

  /* ------------------------------------------------------------ lazy images */
  var io = null;
  function hydrateImg(img) {
    if (!img.hasAttribute('data-lazy')) return;
    var s = img.getAttribute('data-src');
    var ss = img.getAttribute('data-srcset');
    if (ss) img.setAttribute('srcset', ss);
    if (s) img.setAttribute('src', s);
    img.removeAttribute('data-lazy');
  }
  function lazyScan() {
    var pending = root.querySelectorAll('img[data-lazy]');
    if (!pending.length) return;
    if (!('IntersectionObserver' in window)) {
      pending.forEach(hydrateImg);
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          hydrateImg(en.target);
          io.unobserve(en.target);
        });
      }, { rootMargin: '400px 0px' });
    }
    pending.forEach(function (img) {
      if (img.closest('[hidden]')) return;   // a tab that is not showing
      io.observe(img);
    });
  }

  /* ----------------------------------------------------------------- wiring */
  tiles.forEach(function (t) {
    t.addEventListener('click', function () { openFor(t); });
  });

  if (dMinus) dMinus.addEventListener('click', function () {
    if (dQty) dQty.value = String(Math.max(1, (parseInt(dQty.value, 10) || 1) - 1));
    clampQty();
  });
  if (dPlus) dPlus.addEventListener('click', function () {
    if (dQty) dQty.value = String((parseInt(dQty.value, 10) || 1) + 1);
    clampQty();
  });
  if (dQty) dQty.addEventListener('change', clampQty);

  if (dAdd) dAdd.addEventListener('click', function () {
    if (!current) return;
    var vid = current.getAttribute('data-variant');
    var want = clampQty();
    if (MAX_PER) {
      var have = qtyOf(vid);
      if (have + want > MAX_PER) {
        note('You can order up to ' + MAX_PER + ' of each sample. You already have ' + have + '.', 'err');
        return;
      }
    }
    dAdd.disabled = true;
    note('Adding…');
    addSample(vid, want).then(function () {
      note((current.getAttribute('data-short') || 'Sample') + ' added — ' + qtyOf(vid) + ' in your cart.', 'ok');
      say((current.getAttribute('data-short') || 'Sample') + ' added. ' + (cart ? cart.item_count : 0) + ' items in cart.');
      if (dQty) dQty.value = '1';
    })['catch'](function (err) {
      note(String((err && err.message) || 'Could not add that sample. Please try again.'), 'err');
    }).then(function () {
      if (dAdd) dAdd.disabled = current ? current.getAttribute('data-available') !== '1' : false;
    });
  });

  openCartBtns.forEach(function (b) {
    b.addEventListener('click', function () { openCartOnly(); });
  });

  if (dlg) {
    dlg.addEventListener('close', function () {
      current = null;
      dlg.removeAttribute('data-cartonly');
      note('');
    });
    // Click on the backdrop closes, like the Forbo dialog.
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) dlg.close();
    });
  }

  fields.forEach(function (f) {
    var ta = f.querySelector('textarea');
    if (!ta) return;
    ta.addEventListener('change', function () { pushQuestionnaire(); });
    ta.addEventListener('blur', function () { pushQuestionnaire(); });
    ta.addEventListener('input', function () { saveLocal(); paintStatus(); });
  });

  /* -------------------------------------------------------------- start up */
  getCart().then(function (c) {
    cart = c;
    hydrateFromCart();
    paint();
    lazyScan();
  })['catch'](function () {
    // Cart unreachable: the page is still fully browsable, the tray just says
    // nothing is selected rather than inventing a number.
    paint();
    lazyScan();
  });

  // Another part of the page (the theme's own cart drawer) changed the cart.
  document.addEventListener('cart:refresh', function () {
    getCart().then(function (c) { cart = c; paint(); reapProjectInfo(); });
  });
})();
